export function numberMask(value = ""){
  return value.replace(/\D/g, "")
  .replace(/^(\d)/, "R$ $1")
  .replace(/(\d)(\d{2})$/, "$1,$2")
  .replace(/(?=(\d{3})+(\D))\B/g, ".")
}